import React, { useEffect } from 'react'
import styled from 'styled-components'
import { MainHolder, MainLeft, MainRight, Payoff } from '../components/Utils'
import { UIStore } from '../stores/UIStore'
import { colors } from '../variables'
import { Container, Row, Col } from 'react-grid-system'

const References = () => {
  useEffect(() => {
    UIStore.setBackgroundShade(colors.green)
    UIStore.setFooterBg(colors.white)
  }, [])

  return (
    <>
      <LandingArea />
      <div
        style={{
          backgroundColor: colors.green,
          display: 'flex',
        }}
      >
        <MainHolder
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: 200,
            paddingBottom: 150,
          }}
        >
          <div style={{ display: 'flex' }}>
            <MainLeft>
              <ReferenceTitle>Dagens Nyheter</ReferenceTitle>
              <ReferenceTitle>Carnegie</ReferenceTitle>
              <ReferenceTitle>ATG</ReferenceTitle>
              <ReferenceTitle>Bonnier</ReferenceTitle>
              <ReferenceTitle>Svenska Spel</ReferenceTitle>
              <ReferenceTitle>Lorem ipsum</ReferenceTitle>
            </MainLeft>
            <MainRight></MainRight>
          </div>
        </MainHolder>
      </div>
    </>
  )
}

const LandingArea = () => (
  <LandingHolder>
    <Container>
      <Row>
        <Col>
          <h1>Våra referenser</h1>
        </Col>
        <Col>
          <Payoff style={{ color: colors.white }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </Payoff>
        </Col>
      </Row>
    </Container>
  </LandingHolder>
)

const LandingHolder = styled.div`
  padding-top: 140px;
  box-sizing: border-box;
`

const ReferenceTitle = styled.h2`
  font-weight: 600;
  font-size: 64px;
  line-height: 70px;
  color: ${colors.white};
  margin-bottom: 40px;
`

export default References
